import { render, staticRenderFns } from "./TasksBreadcrumb.vue?vue&type=template&id=b012641a&scoped=true"
import script from "./TasksBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TasksBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./TasksBreadcrumb.vue?vue&type=style&index=0&id=b012641a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b012641a",
  null
  
)

export default component.exports